export default function Footer() {
  const groups = [
    { title: "版面速览", items: ["热瓜首屏", "新瓜速递", "持续追踪", "热度榜", "打包合集"] },
    { title: "吃瓜指南", items: ["更新规则", "口径说明", "常见问题", "求证标注"] },
    { title: "关于本站", items: ["关于免费吃瓜", "聚合理念", "内容说明", "联系方式"] },
  ];

  return (
    <footer className="bg-emerald-700 text-emerald-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/15 text-white">
                <i className="ri-water-flash-line text-lg"></i>
              </span>
              <span className="text-lg font-extrabold tracking-tight">免费吃瓜</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-emerald-100/80">
              把同一类瓜汇总打包成清晰线索，多瓜连吃、一次性看全，按顺序整理不遗漏。
            </p>
            <div className="mt-4 flex items-center gap-3 text-emerald-100/80">
              <a href="#board" aria-label="回到顶部" className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 transition-colors hover:bg-white/20">
                <i className="ri-arrow-up-line"></i>
                <span className="sr-only">回到顶部</span>
              </a>
              <span className="text-xs text-emerald-200/70">内容仅供参考，请理性看待网传信息</span>
            </div>
          </div>

          {groups.map((g) => (
            <div key={g.title}>
              <h3 className="text-sm font-semibold text-white">{g.title}</h3>
              <ul className="mt-3 space-y-2">
                {g.items.map((it) => (
                  <li key={it}>
                    <a href="#board" className="text-sm text-emerald-100/70 transition-colors hover:text-white">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-white/15 pt-6 sm:flex-row">
          <p className="text-xs text-emerald-100/60">© 2026 免费吃瓜 · 多瓜连吃打包 · 免费吃瓜合集</p>
          <p className="flex items-center gap-1.5 text-xs text-emerald-100/60">
            <i className="ri-heart-3-line"></i>理性吃瓜，拒绝造谣
          </p>
        </div>
      </div>
    </footer>
  );
}